export const GET_CLASSES_REQUEST = 'GET_CLASSES_REQUEST';
export const GET_CLASSES_SUCCESS = 'GET_CLASSES_SUCCESS';
export const GET_CLASSES_FAILED = 'GET_CLASSES_FAILDER';

export const GET_CLASSES_BY_DATE_REQUEST = 'GET_CLASSES_BY_DATE_REQUEST';
export const GET_CLASSES_BY_DATE_SUCCESS = 'GET_CLASSES_BY_DATE_SUCCESS';
export const GET_CLASSES_BY_DATE_FAILED = 'GET_CLASSES_BY_DATE_FAILED';

export const GET_CLASSES_BY_DATE_RANGE_REQUEST = 'GET_CLASSES_BY_DATE_RANGE_REQUEST';
export const GET_CLASSES_BY_DATE_RANGE_SUCCESS = 'GET_CLASSES_BY_DATE_RANGE_SUCCESS';
export const GET_CLASSES_BY_DATE_RANGE_FAILED = 'GET_CLASSES_BY_DATE_RANGE_FAILED';

export const CREATE_CLASS_REQUEST = 'CREATE_CLASS_REQUEST';
export const CREATE_CLASS_SUCCESS = 'CREATE_CLASS_SUCCESS';
export const CREATE_CLASS_FAILED = 'CREATE_CLASS_FAILED';

export const UPDATE_CLASS_REQUEST = 'UPDATE_CLASS_REQUEST';
export const UPDATE_CLASS_SUCCESS = 'UPDATE_CLASS_SUCCESS';
export const UPDATE_CLASS_FAILED = 'UPDATE_CLASS_FAILED';

export const UPDATE_CLASS_SERIES_REQUEST = 'UPDATE_CLASS_SERIES_REQUEST';
export const UPDATE_CLASS_SERIES_SUCCESS = 'UPDATE_CLASS_SERIES_SUCCESS';
export const UPDATE_CLASS_SERIES_FAILED = 'UPDATE_CLASS_SERIES_FAILED';

export const DELETE_CLASS_REQUEST = 'DELETE_CLASS_REQUEST';
export const DELETE_CLASS_SUCCESS = 'DELETE_CLASS_SUCCESS';
export const DELETE_CLASS_FAILED = 'DELETE_CLASS_FAILED';

export const DELETE_CLASS_SERIES_REQUEST = 'DELETE_CLASS_SERIES_REQUEST';
export const DELETE_CLASS_SERIES_SUCCESS = 'DELETE_CLASS_SERIES_SUCCESS';
export const DELETE_CLASS_SERIES_FAILED = 'DELETE_CLASS_SERIES_FAILED';

export const GET_CLASS_BOOKERS_REQUEST = 'GET_CLASS_BOOKERS_REQUEST';
export const GET_CLASS_BOOKERS_SUCCESS = 'GET_CLASS_BOOKERS_SUCCESS';
export const GET_CLASS_BOOKERS_FAILED = 'GET_CLASS_BOOKERS_FAILED';

export const GET_CLASS_MEMBERS_REQUEST = 'GET_CLASS_MEMBERS_REQUEST';
export const GET_CLASS_MEMBERS_SUCCESS = 'GET_CLASS_MEMBERS_SUCCESS';
export const GET_CLASS_MEMBERS_FAILED = 'GET_CLASS_MEMBERS_FAILED';

export const CHECK_IN_USER_REQUEST = 'CHECK_IN_USER_REQUEST';
export const CHECK_IN_USER_SUCCESS = 'CHECK_IN_USER_SUCCESS';
export const CHECK_IN_USER_FAILED = 'CHECK_IN_USER_FAILED';

export const CHECK_OUT_USER_REQUEST = 'CHECK_OUT_USER_REQUEST';
export const CHECK_OUT_USER_SUCCESS = 'CHECK_OUT_USER_SUCCESS';
export const CHECK_OUT_USER_FAILED = 'CHECK_OUT_USER_FAILED';

export const LOAD_MORE_CLASSES_REQUEST = 'LOAD_MORE_CLASSES_REQUEST';
export const LOAD_MORE_CLASSES_SUCCESS = 'LOAD_MORE_CLASSES_SUCCESS';
export const LOAD_MORE_CLASSES_FAILED = 'LOAD_MORE_CLASSES_FAILED';

export const CLEAR_CLASS_ERRORS = 'CLEAR_CLASS_ERRORS';

export const BOOK_CLASS_REQUEST = 'BOOK_CLASS_REQUEST';
export const BOOK_CLASS_SUCCESS = 'BOOK_CLASS_SUCCESS';
export const BOOK_CLASS_FAILED = 'BOOK_CLASS_FAILED';

export const CANCEL_CLASS_BOOKING_REQUEST = 'CANCEL_CLASS_BOOKING_REQUEST';
export const CANCEL_CLASS_BOOKING_SUCCESS = 'CANCEL_CLASS_BOOKING_SUCCESS';
export const CANCEL_CLASS_BOOKING_FAILED = 'CANCEL_CLASS_BOOKING_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/ClassesActionTypes.js